import React, { useContext, useEffect, useState } from "react";
import { useUser, updateUser } from "~/assets/js/Api/userApi";
import { EditProfileForm } from "~/assets/js/components/Forms/modules";
import GoBackTitle from "../../components/GoBackTitle";
import CustomerNotification from "../../components/CustomerNotification";
import { ACTIONS, CustomerAreaContext } from "../../CustomerAreaProvider";
import SimpleButton from "~/assets/js/components/Button/SimpleButton";

const PATH = "profile";

const EditProfile = () => {
    const [isLoading, setLoading] = useState(false);
    const [notification, setNotification] = useState({
        show: false,
        variant: "success",
    });
    const { dispatch } = useContext(CustomerAreaContext);

    const handleEditProfile = async (
        { firstName, lastName, email },
        dirty = false
    ) => {
        if (!dirty) {
            return goToOverview();
        }

        setLoading(true);

        const updateProfile = await updateUser({
            name: firstName,
            lastName: lastName,
            email: email,
        });

        setLoading(false);

        if (updateProfile.ok) {
            setNotification({ show: true, variant: "success" });
            dispatch({ type: ACTIONS.LOGIN, payload: updateProfile.user });
            return goToOverview();
        }

        return setNotification({ show: true, variant: "danger" });
    };

    // Remove notif on unmount
    useEffect(() => {
        return () => {
            setNotification({
                ...notification,
                show: false,
            });
        };
    }, []);

    const goToOverview = () =>
        dispatch({ type: "CHANGE_PAGE", payload: "overview" });

    const { user } = useUser();

    const defaultFormValues = {
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
    };

    return (
        <>
            <GoBackTitle path={PATH} />
            <CustomerNotification
                show={notification.show}
                path={PATH}
                variant={notification.variant}
            />
            <EditProfileForm
                onSubmit={handleEditProfile}
                isLoading={isLoading}
                formValues={defaultFormValues}
            />
            <div className="center-wrapper">
                <SimpleButton
                    customStyle="abort-btn"
                    onClick={goToOverview}
                    label={"customerArea.nav.abort"}
                />
            </div>
        </>
    );
};

export default EditProfile;
